import styled from '@emotion/styled'
import { faQrcode } from '@fortawesome/pro-duotone-svg-icons'
import { memo } from 'react'
import QrReader from 'react-qr-reader'

import Popup from '../popup/Popup'

const ScanQrCode = ({ onScan, onError, ...restProps }) => {
  return (
    <Popup icon={faQrcode} {...restProps}>
      <QrCodeContainer
        onError={onError}
        onScan={onScan}
        facingMode='environment'
        delay={300}
      />
    </Popup>
  )
}

export default memo(ScanQrCode)

const QrCodeContainer = styled(QrReader)`
  height: 270px;
  width: 270px;
  margin-left: auto;
  margin-right: auto;
  div {
    border: none !important;
    box-shadow: none !important;
  }
  video {
    height: 100%;
    width: 100%;
    object-fit: cover !important;
    border: 2px solid;
    border-radius: 10px;
  }
`
